import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  apiUrl: 'https://dev.api.petszelconnectbackend.petszel.com/',
  production: false,
  development: true,
  dashboardUrl: 'https://dev.shelter.petszel.com',
  petParentAppUrl: 'https://dev.app.petszel.com/',
  logger: {
    level: NgxLoggerLevel.DEBUG,
    serverLogLevel: NgxLoggerLevel.ERROR,
    disableConsoleLogging: false,
  }
};
